import { Injectable } from '@angular/core';

/**
 * Traduce le label delle metriche basandosi sul code
 */
@Injectable({ providedIn: 'root' })
export class MetricTranslationService {
  private readonly labels: Record<string, string> = {
    BLACK_COUNTER: $localize`:@@metric.BLACK_COUNTER:Contatori BN`,
    COLOR_COUNTER: $localize`:@@metric.COLOR_COUNTER:Contatori Colore`,
    BLACK_TONER: $localize`:@@metric.BLACK_TONER:Toner Nero`,
    CYAN_TONER: $localize`:@@metric.CYAN_TONER:Toner Ciano`,
    MAGENTA_TONER: $localize`:@@metric.MAGENTA_TONER:Toner Magenta`,
    YELLOW_TONER: $localize`:@@metric.YELLOW_TONER:Toner Giallo`,
    BLACK_DRUM: $localize`:@@metric.BLACK_DRUM:Tamburo Nero`,
    CYAN_DRUM: $localize`:@@metric.CYAN_DRUM:Tamburo Ciano`,
    MAGENTA_DRUM: $localize`:@@metric.MAGENTA_DRUM:Tamburo Magenta`,
    YELLOW_DRUM: $localize`:@@metric.YELLOW_DRUM:Tamburo Giallo`,
    WASTE_TONER: $localize`:@@metric.WASTE_TONER:Vaschetta di recupero`,
    STATUS: $localize`:@@metric.STATUS:Stato`,
    MAINTENANCE_TA: $localize`:@@metric.MAINTENANCE_TA:Maintenance (TA)`,
    MAINTENANCE_CA: $localize`:@@metric.MAINTENANCE_CA:Maintenance (CA)`,
    FUSING_BELT: $localize`:@@metric.FUSING_BELT:Fusing Belt/Roller`,
    PRESSURE_ROLLER: $localize`:@@metric.PRESSURE_ROLLER:Pressure Roller`,
    TRANSFER_BELT: $localize`:@@metric.TRANSFER_BELT:Transfer Belt`,
    SECONDARY_TRANSFER_BELT: $localize`:@@metric.SECONDARY_TRANSFER_BELT:Secondary Transfer Belt/Roller`,
    TRANSFER_BLADE: $localize`:@@metric.TRANSFER_BLADE:Transfer Blade`,
    CYAN_MAIN_CHARGER: $localize`:@@metric.CYAN_MAIN_CHARGER:Cyan Main Charger`,
    MAGENTA_MAIN_CHARGER: $localize`:@@metric.MAGENTA_MAIN_CHARGER:Magenta Main Charger`,
    YELLOW_MAIN_CHARGER: $localize`:@@metric.YELLOW_MAIN_CHARGER:Yellow Main Charger`,
    BLACK_MAIN_CHARGER: $localize`:@@metric.BLACK_MAIN_CHARGER:Black Main Charger`,
    FUSING_WEB_UNIT: $localize`:@@metric.FUSING_WEB_UNIT:Fusing Web Unit`,
    BLACK_DEVELOPER: $localize`:@@metric.BLACK_DEVELOPER:Black Developer`,
    TRANSFER_UNIT: $localize`:@@metric.TRANSFER_UNIT:Transfer Unit`,
    PTC: $localize`:@@metric.PTC:Primary Transfer Cleaner Unit (PTC)`,
    TRANSFER_MODULE: $localize`:@@metric.TRANSFER_MODULE:Transfer Module`,
    IMAGING_KIT: $localize`:@@metric.IMAGING_KIT:Imaging Kit`,
    FUSER: $localize`:@@metric.FUSER:Fuser`,
    TRANSFER_ROLLER: $localize`:@@metric.TRANSFER_ROLLER:Transfer Roller`,
  };

  getLabel(code: string, fallback?: string): string {
    return this.labels[code] ?? fallback ?? code;
  }
}
